<template>
  <div class="is-pulled-right">
    <router-link class="button is-small is-primary" :to="path">
     {{ displayText }}
    </router-link>
  </div>
</template>
 
<script>
export default {
  name: 'TrialBarButton',
  props: ['displayText', 'path']
};
</script>